export const createHistory = () => {
  const getCurrentState = () => window.history.state && window.history.state.state || {};

  return {
    get location() {
      return {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: getCurrentState(),
        key: getCurrentState().key || ''
      };
    },

    replace: (location, state = {}) => {
      window.history.replaceState(Object.assign({}, state), '', typeof location === 'string' ? `${window.location.origin}${location}` : location.toString());
    },
    push: (location, state = {}) => {
      window.history.pushState(Object.assign({}, state), '', typeof location === 'string' ? `${window.location.origin}${location}` : location.toString());
    }
  };
};